import { HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { Observable } from 'rxjs';
import { RegistrarUsuarioCommand, interfaceAutoridadesXTipo } from '../../commons/class/OrganosXTipo.class'
import { BaseResponsePagination } from '../../commons/class/BaseResponsePagination.interface';
import { ENV_TOKEN } from '../../app-module.token';


@Injectable({
  providedIn: 'root'
})
export class AltaUsuarioService {
  private readonly baseUrl = 'oaj.icoij.gateway/icoij/getOrgIUser';

  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;
  private httpService: HttpService = inject(HttpService);
  readonly environment = inject(ENV_TOKEN);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Busca órganos por página y tamaño de página
   * @param page 
   * @param pageSize 
   * @param idOrgano 
   * @param query 
   * @returns 
   */
  buscarOrgano(page: number, pageSize: number, idOrgano: number, query = ''): Observable<BaseResponsePagination<interfaceAutoridadesXTipo[]>> {
    const params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize)
      .set('idOrgano', idOrgano)
      .set('query', query);


    return this.httpService.getRequest(`${this.baseUrl}/BusquedaNotificaciones${this.buildQueryString(params)}`) as Observable<BaseResponsePagination<interfaceAutoridadesXTipo[]>>;
  }

  /**
   * Construye una cadena de consulta a partir de los parámetros HTTP proporcionados, si la cadena de consulta no está vacía, se le antepone un signo de interrogación, de lo contrario se devuelve una cadena vacía
   * @param params 
   * @returns 
   */
  private buildQueryString(params: HttpParams): string {
    const query = params.toString();
    return query ? `?${query}` : '';
  }

  /**
   * Obtiene los órganos por tipo de organismo, se construye la ruta para la consulta utilizando el ID del tipo de organismo, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta como un Observable
   * @param idTipoOrgano 
   * @returns 
   */
  getOrganosxTipo(idTipoOrgano: number): Observable<any> {
    const funcion = "icoij/getOrgIUser";
    const ruta = `${this.urlRaiz}/${funcion}/${idTipoOrgano}`;
    return this.httpService.getRequest(ruta);
  }

  /**
   * Registra nuevos usuarios, se construye la ruta para el registro utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  RegistrarUsuarios(request: RegistrarUsuarioCommand) {
    const funcion = "icoij/RegisterUsers";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   * Obtiene los tipos de órganos OIJ, se construye la ruta para la consulta utilizando la URL raíz y la función correspondiente, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta como un Observable
   * @returns 
   */
  getTiposOrganismoOIJ() {
    const funcion = "icoij/getTypeOrg";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.getRequest(ruta);
  }

}
